import React from "react";
import { Card } from "../modules/Settings/Tests";

export function SettingsTestCardPage(props) {
  return <Card {...props} />;
}
